import { ICapsuleFolder, IExploringElement } from "../../typings/board/Models";
import { HIERARCHY_SERVICE, HierarchyService } from "../hierarchy-service/hierarchy.service";
import { ExploringElement } from "./exploringElement";

export abstract class AbstractHierarchySidenav {
    protected rootFolder: IExploringElement;
    protected expandedFolderPaths : string[];
    protected exploringData: IExploringElement[];
    protected abstract navigateFolder(selectedCapsule: IExploringElement): void;
    private basicPadding : number;
    static $inject = [HIERARCHY_SERVICE, "$mdToast", "$mdDialog"];

    constructor(protected hierarchyService: HierarchyService,
        protected $mdToast: ng.material.IToastService, protected $mdDialog: ng.material.IDialogService) {
        this.basicPadding = 16;
        this.expandedFolderPaths = [];
        this.exploringData = [];
        this.hierarchyService.$getRootFolder()
            .subscribe((value) => {
                if (value != null) {
                    this.rootFolder = new ExploringElement(0, value.name, false, value, true, value);
                    this.exploringData = [];
                    this.normalizeData(value, true);
                    this.updateExpandingFolders();
                }
        });
    }
    protected getPadding(folder : IExploringElement): any {
        return {paddingLeft:folder.leftPadding};
    }

    protected normalizeData(folder: ICapsuleFolder, isVisible: boolean, givenPadding:number = 0): void {
        if (folder) {
            if (folder.subFolders) {
                folder.subFolders.forEach(subFolder => {

                    this.exploringData.push(new ExploringElement(
                                                givenPadding,
                                                subFolder.name,
                                                false,
                                                folder,
                                                this.expandedFolderPaths.indexOf(subFolder.relativePath) >= 0? true:isVisible,
                                                subFolder));
                    this.normalizeData(subFolder, false, this.basicPadding + givenPadding);
                });
            }
        }
    }

    private updateExpandingFolders():void {
        var _self_ : AbstractHierarchySidenav = this;
        this.exploringData.forEach(folder => {
            if (!folder.isVisible) {
                folder.isVisible = _self_.exploringData.find(el => el.parent.relativePath === folder.parent.relativePath).isVisible;
            }
            if (folder.originCapsule.relativePath === this.hierarchyService.lastSelectedFolder.relativePath) {
                folder.isSelected = true;
            }
        });
    }

    protected expandCollapseFolderCascade(collapsingExpandingFolderPath: string, forceValue: Boolean): void {
        this.exploringData.forEach(folder => {
            if ((folder.parent.relativePath === collapsingExpandingFolderPath) &&
                (folder.originCapsule.relativePath !== collapsingExpandingFolderPath)) {
                folder.isVisible = forceValue != null ? forceValue.valueOf() : !folder.isVisible;
                if (!folder.isVisible) {
                /* We just collapse a folder, we have to collapse all the subfolders*/
                    this.expandedFolderPaths = this.expandedFolderPaths
                                                .filter(function(data:string):boolean {
                                                    return data === folder.originCapsule.relativePath; });
                    this.expandCollapseFolderCascade(folder.originCapsule.relativePath, false);
                } else {
                    this.expandedFolderPaths.push(folder.originCapsule.relativePath);
                }
            }
        });
    }
    protected isExpandable(folder: IExploringElement): Boolean {
        if (folder) {
            if (folder.originCapsule) {
                if ((folder.originCapsule.files && folder.originCapsule.files.length > 0) ||
                    (folder.originCapsule.subFolders && folder.originCapsule.subFolders.length > 0)) {
                    return true;
                }
            }
        }
        return false;
    }
}


// WEBPACK FOOTER //
// ./app/hierarchy-support/abstractHierarchySidenav.ts